// extracted by css-extract-rspack-plugin
export default {"grid":"Grid__grid--a0CXZ","col2":"Grid__col2--RsgJz","colGap":"Grid__colGap--ovabr","sub":"Grid__sub--FEsKg"};